import _merge from 'lodash/merge';
import Store from 'lightningjs-redux';
import { Lightning } from '@lightningjs/sdk';
import { logout } from '../../logic/pairing/unpair.actions';
import { removeSplashScreen } from '../../logic/app/app.utils';
import { HOME_PATH, navigateTo, navigateToAliasHome } from '../routes/routes.utils';
import { BrandIcon } from '../tornado/brand-icon/brandIcon.component';
import { Button } from '../tornado/button/button.component';
import { getInitialStyle } from './deviceGate.style';
import connect from './deviceGate.connector';
import { t } from '../i18n';

export class DeviceGate extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {},
        Logo: {
          type: BrandIcon,
        },
        Container: {
          Title: {
            text: {
              text: t('pairing.devicesGate.title'),
            },
          },
          Description: {
            text: {
              text: t('pairing.devicesGate.description'),
            },
          },
          Buttons: {
            Retry: {
              type: Button,
              label: t('error.retry'),
            },
            Logout: {
              type: Button,
              label: t('pairing.welcome.disconnect'),
            },
          },
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._index = 0;
  }

  _active() {
    removeSplashScreen();

    this._unsubscribe = connect(this);
  }

  _inactive() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  set deeplink(value) {
    this._deeplink = value;
  }

  _getFocused() {
    return this.tag('Buttons').children[this._index];
  }

  _handleLeft() {
    this._index = Math.max(this._index - 1, 0);

    return true;
  }

  _handleRight() {
    this._index = Math.min(this._index + 1, 1);

    return true;
  }

  _handleEnter() {
    if (this._index) {
      Store.dispatch(logout()).finally(() => navigateToAliasHome(false));
    } else {
      navigateTo(this._deeplink || HOME_PATH, false);
    }

    return true;
  }
}
